import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/LangContext";

export default function WhatWeDontMake() {
  const { t } = useLang();
  return (
    <section className="relative py-28 lg:py-40 bg-[#070708] overflow-hidden" data-testid="dontmake-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.28em] text-red-400 font-mono-ef">
              — {t.dontmake.overline}
            </div>
            <h2 className="mt-6 font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-[-0.035em]">
              {t.dontmake.title}
            </h2>
            <p className="mt-6 text-lg text-white/60 max-w-lg leading-relaxed">
              {t.dontmake.subtitle}
            </p>
            <div className="mt-8 p-6 border border-white/10 rounded-2xl bg-white/[0.02]">
              <div className="flex items-start gap-3">
                <span className="mt-1 w-2 h-2 rounded-full bg-red-500 shadow-[0_0_10px_rgba(239,68,68,0.7)]" />
                <p className="text-sm text-white/70 leading-relaxed">{t.dontmake.note}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <ul className="grid grid-cols-2 gap-x-6">
              {t.dontmake.list.map((item, i) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ delay: i * 0.05, duration: 0.5 }}
                  className="flex items-center gap-4 py-5 border-b border-white/10"
                  data-testid={`dontmake-${item.toLowerCase()}`}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-red-500 shrink-0">
                    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                  <span className="font-display text-xl lg:text-2xl font-semibold text-white/85 line-through decoration-red-500/60 decoration-[1.5px]">
                    {item}
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
